import { IEntity } from "@/entity/shared/EntityStoreTypes";
import { getCssVariableColor } from "./get-main-color";
import routeIsValidForProjectSelector from "./routeIsValidForProjectSelector";
import router from "@/router";

const routeNameOnlyColorRelative = [
    'invoice-pdf'
];

export function updateMainColorHeaderForProject(entityLabel?: IEntity["label"]) {
    // Si la route actuelle n'est pas une page projet alors on met le theme avec la couleur par défaut;
    if (!routeIsValidForProjectSelector() && !routeNameOnlyColorRelative.includes(router.currentRoute.name!)) return updateMainColorHeader(getCssVariableColor('--c-main-france'));

    // Sinon on met le theme en fonction de l'entité du projet;
    switch (entityLabel) {
        case 'CAN':
            updateMainColorHeader(getCssVariableColor('--c-main-canada'));
            break;
        case 'FRA':
        default: 
            updateMainColorHeader(getCssVariableColor('--c-main-france'));
            break;
    }
}

// Couleurs disponibles ici src\style\color.scss
function updateMainColorHeader(color: string) {
    const r = document.querySelector(':root') as any; // any car notre version de typescript n'as pas les dernière déclaration lié aux variable CSS.
    r.style.setProperty('--c-main-header', color);
}